var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1605_1543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.52683 3.80657C9.26683 4.06657 9.26683 4.48657 9.52683 4.74657L12.1135 7.33324H2.00016C1.6335 7.33324 1.3335 7.63324 1.3335 7.99991C1.3335 8.36657 1.6335 8.66657 2.00016 8.66657H12.1202L9.5335 11.2532C9.2735 11.5132 9.2735 11.9332 9.5335 12.1932C9.7935 12.4532 10.2135 12.4532 10.4735 12.1932L14.2002 8.46657C14.4602 8.20657 14.4602 7.78657 14.2002 7.52657L10.4668 3.80657C10.2135 3.54657 9.78683 3.54657 9.52683 3.80657Z",
    fill: "#00A0F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1605_1543"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBlue);
export default __webpack_public_path__ + "static/media/ArrowRightBlue.5fa4457797fe9b27fea3088b82b9175a.svg";
export { ForwardRef as ReactComponent };